import React from 'react';
import { Camera, Palette, Package, ShoppingBag } from 'lucide-react';
import Header from '../components/Header';
import Article from '../components/Article';
import elimika from '../components/assets/Elimika.png';
import bff from '../components/assets/bff.png';
import './products.css';

const Products = () => {
  return (
    <div className="products" id="apps">
      <Header />
      
      <div className="products__container-wrapper">
        <div className="products__heading">
          <h1 className="products__title">
            We are <span className="products__title-accent">diverse</span>
          </h1>
        </div>
        
        <div className="products__grid">
          <Article 
            imgUrl="https://img.freepik.com/free-vector/cute-cool-boy-dabbing-pose-cartoon-vector-icon-illustration-people-fashion-icon-concept-isolated_138676-5680.jpg?ga=GA1.1.958133876.1746731698&semt=ais_hybrid&w=740"
            text="Schools bands competition reality TV show - launching young talent into the market."
            url="/bff"
            btnText="Explore BFF"
            icon={<Palette size={24} />}
          />
          
          <Article 
            imgUrl="https://img.freepik.com/premium-photo/education-school-knowledge-people-concept-happy-smiling-african-american-student-girl-bachelor-cap-with-books-sitting-table-dreaming-home_380164-102088.jpg?ga=GA1.1.958133876.1746731698&semt=ais_hybrid&w=740"
            text="Connect. Learn. Succeed - Achieve your academic goals with personalized, one-on-one, team and group tutoring from top experts in the field."
            url="/elimika"
            btnText="Discover Elimika"
            icon={<Camera size={24} />}
          />
          
          {/* <Article 
            imgUrl={bff}
            text="Schools bands competition reality TV show - launching young talent into the market."
            url="/bff"
            btnText="Explore BFF"
            icon={<ShoppingBag size={24} />}
          />
          
          <Article 
            imgUrl={elimika}
            text="Connect. Learn. Succeed - Achieve your academic goals with personalized, one-on-one, team and group tutoring from top experts in the field."
            url="/elimika"
            btnText="Discover Elimika"
            icon={<Package size={24} />}
          />
          
          <Article 
            imgUrl={bff}
            text="Schools bands competition reality TV show - launching young talent into the market."
            url="/bff"
            btnText="Explore BFF" 
            icon={<Palette size={24} />}
          />
          
          <Article 
            imgUrl={elimika}
            text="Connect. Learn. Succeed - Achieve your academic goals with personalized, one-on-one, team and group tutoring from top experts in the field."
            url="/elimika"
            btnText="Discover Elimika"
            icon={<Camera size={24} />}
          />
           */}
          {/* Uncomment when apps are updated
          <Article imgUrl={Products03} text="App3" btnText="Learn More" />
          <Article imgUrl={Products04} text="App4" btnText="Learn More" />
          <Article imgUrl={Products05} text="App5" btnText="Learn More" />
          */}
        </div>
      </div>
    </div>
  );
};

export default Products;